// Agent slug from /workshop/<slug>/, or '' for the home page and anything else.
export function agentSlugFromPath(pathname) {
  const basePath = process.env.NEXT_PUBLIC_BASENAME || '/workshop';
  const segments = String(pathname || '')
    .replace(new RegExp(`^${basePath}`), '')
    .split('/')
    .filter(Boolean);

  if (segments.length !== 1) return '';
  const slug = segments[0].toLowerCase();
  return slug.includes('.') ? '' : slug;
}
